<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<a id="title28"></a>
<div class="tp-title"><strong class="b">Dictionary of Mysticism</strong></div>
<div class="tp-author"><strong class="b">Frank Gaynor</strong></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537009_tp01.vue?36b163ca